/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductGrid_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontFeaturedSection_user$ref: FragmentReference;
export type StorefrontFeaturedSection_user = {|
  +$fragmentRefs: StorefrontProductGrid_user$ref,
  +$refType: StorefrontFeaturedSection_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cc33e765bcfb2cbd86cb6ba9c7c0cfd9';
module.exports = node;
